import { render, staticRenderFns } from "./SalarySlipForm.vue?vue&type=template&id=17cbcdc4"
import script from "./SalarySlipForm.vue?vue&type=script&lang=js"
export * from "./SalarySlipForm.vue?vue&type=script&lang=js"
import style0 from "./SalarySlipForm.vue?vue&type=style&index=0&id=17cbcdc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports